import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { MDSIcon, MDSIconKind, MDSIconColor } from "@/mds";
import { MDSLink } from "@/mds/components/text";
import { MDSSectionSlotName } from "@/mds/components/section";
import { windowModule } from "@/modules/window";
import { ApiKeyItemList } from "@/pages/integrations/api/integrations-api-page-content-list";
import { IntegrationsLayoutBottomBuffer } from "@/pages/integrations/shared/integrations-layout";
import {
  StyledCardIntegrationInstruction,
  StyledContentList,
  StyledContentSectionTitleWrapper,
  StyledContentStatusWrapper,
  StyledContentWrapper,
} from "@/pages/integrations/shared/integrations.styles";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

import { FC, useCallback } from "react";

export const IntegrationsApiPageContent: FC = observer(() => {
  const { store } = useAppStore();
  const isConnected = store.apiKeys.allActiveApiKeys.length > 0;

  const handleClickDevDocsLink = useCallback(() => {
    trackEvent(TrackedEvent.ApiDevDocsLinkClick);
    windowModule.openInNewTab({ url: new URL("https://docs.mem.ai") });
  }, []);

  return (
    <StyledContentWrapper>
      <StyledCardIntegrationInstruction
        title={
          <StyledContentSectionTitleWrapper>
            <MDSIcon kind={MDSIconKind.Merge} />
            API Integration
          </StyledContentSectionTitleWrapper>
        }
      >
        <div slot={MDSSectionSlotName.HeaderRightAddon}>
          <StyledContentStatusWrapper>
            {isConnected ? "Connected" : "Not connected"}
            <MDSIcon
              kind={isConnected ? MDSIconKind.CheckCircleSolid : MDSIconKind.CircleSolid}
              color={isConnected ? MDSIconColor.Positive : MDSIconColor.Danger}
            />
          </StyledContentStatusWrapper>
        </div>
        <StyledContentList>
          <li>API keys help you connect Mem with other apps and services you use.</li>
          <li>
            Whether you&apos;re building custom integrations or using third-party tools, our{" "}
            <DevDocsLink onClick={handleClickDevDocsLink}>API Docs</DevDocsLink> will guide you
            through the process.
          </li>
          <li>Remember to treat your API keys like passwords - keep them private and secure.</li>
        </StyledContentList>
      </StyledCardIntegrationInstruction>
      <ApiKeyItemList />
      <IntegrationsLayoutBottomBuffer />
    </StyledContentWrapper>
  );
});

const DevDocsLink = styled(MDSLink)(({ theme }) => ({
  color: theme.colors.text.link.default,
  fontWeight: theme.fontWeights.medium,
}));
